var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "title" }, [
    _c(
      "div",
      {
        class: ["titleFont", { pointer: _vm.cursor }],
        on: {
          click: function($event) {
            return _vm.$emit("navigation")
          }
        }
      },
      [_vm._v(" " + _vm._s(_vm.title) + " ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }